import config from "../../../config";

export default {
    bookings: {
        error: undefined,
        noContent: undefined,
        loading: false,
        value: [],
        limit: 20,
        limitList: [5, 10, 20, 50, 100, 200],
        page: 1,
        hasFetched: false,
        predicate: ['supplierRef'],
        defaultPredicate: 'supplierRef',
        predicateList: [
            'supplierRef',
            'bookingRef',
            'status',
            'bookingDate',
            'arrivalDate',
            'departureDate',
            'domain',
            'accommodation',
            'siteName',
            "supplierName"
        ],
        orderList: [
            "asc",
            "desc"
        ],
        order: "asc",
        filters: {
            searchword: '',
            season: {
                from: config.business.SEASON_DATE_START,
                to: config.business.SEASON_DATE_END
            },
            bookingPeriod: {
                from: config.business.BOOKING_BOOKING_DATE_START,
                to: config.business.BOOKING_BOOKING_DATE_END,
            },
            arrivalPeriod: {
                from: config.business.BOOKING_ARRIVAL_DATE_START,
                to: config.business.BOOKING_ARRIVAL_DATE_END,
            },
            suppliers: [],
            selectSuppliers: [],
            brands: [],
            domains: [],
            countries: [],
            sites: [],
            accommodations: [],
            status: ['booked', 'pending', 'request', 'rejected', 'request-cancel', 'cancelled', 'unknown'],
            loading: false,
            error: false,
            selected: {
                country: undefined,
                brand: undefined,
                domain: undefined,
                site: undefined,
                accommodation: undefined,
                supplier: undefined,
                status: 'booked'
            }
        },
        csv: undefined,
        tips: [
            {
                title: 'tips.bookingPage.filters.title',
                body: 'tips.bookingPage.filters.body'
            },
            {
                title: 'tips.bookingPage.sortList.title',
                body: 'tips.bookingPage.sortList.body'
            },
            {
                title: 'tips.bookingPage.downloadList.title',
                body: 'tips.bookingPage.downloadList.body'
            },
            {
                title: 'tips.bookingPage.xlsError.title',
                body: 'tips.bookingPage.xlsError.body'
            },
            {
                title: 'tips.bookingPage.search.title',
                body: 'tips.bookingPage.search.body'
            }
        ]
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/booking/state.js